<template>
    <portal to="modal">
        <ModalContent show-header :title="`Signera ${title}`">
            <div v-if="nextStep === ''">
                <BasicSign
                    v-if="basicEnabled"
                    :url="url"
                    :data="data"
                    :tabbnamn="tabbnamn"
                    @success="handleSign"
                    @error="handleError"
                    @cancel="handleCancel"
                />
                <BankIDSign
                    v-if="bankIDEnabled"
                    :url="url"
                    :data="data"
                    @poll="handlePolling"
                    @error="handleError"
                    @cancel="handleCancel"
                />
                <NetIDSign
                    v-if="netIDEnabled"
                    :url="url"
                    :data="data"
                    @poll="handlePolling"
                    @error="handleError"
                    @cancel="handleCancel"
                />
            </div>

            <PollingFrame
                v-if="nextStep === 'polling'"
                :message="pollMesssage"
                :url="pollUrl"
                :data="pollData"
                :type="pollType"
                @success="handleSign"
                @error="handlePollingError"
                @cancel="handleCancel"
            />
        </ModalContent>
    </portal>
</template>

<script setup>
    import { getAuthenticationMethod } from "@/api";
    import BankIDSign from "@/components/Auth/BankIDSign.vue";
    import BasicSign from "@/components/Auth/BasicSign.vue";
    import NetIDSign from "@/components/Auth/NetIDSign.vue";
    import PollingFrame from "@/components/Auth/PollingFrame.vue";
    import ModalContent from "@/components/generic/ModalContent.vue";
    import { computed, ref, toRefs } from "vue";

    const nextStep = ref("");
    const pollMesssage = ref("");
    const pollUrl = ref("");
    const pollData = ref({});
    const pollType = ref("");

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        tabbnamn: {
            type: String,
            required: false,
            default: null,
        },
    });

    const { url, data } = toRefs(props);

    const basicEnabled = computed(() => {
        return getAuthenticationMethod() === "Basic";
    });

    const bankIDEnabled = computed(() => {
        return getAuthenticationMethod() === "BankID";
    });

    const netIDEnabled = computed(() => {
        return getAuthenticationMethod() === "NetID";
    });

    const emit = defineEmits(["success", "error", "cancel"]);

    async function handleSign(data) {
        emit("success", data);
    }

    function handlePolling({ message, url, data, type }) {
        pollMesssage.value = message;
        pollUrl.value = url;
        pollData.value = data;
        pollType.value = type;
        nextStep.value = "polling";
    }

    function handlePollingError(message) {
        emit("error", message);
    }

    function handleError(errors) {
        emit("error", errors);
    }

    function handleCancel() {
        emit("cancel");
    }
</script>

<style lang="scss">
    @import "@/style/variables";

    .sign-frame {
    }
</style>
